<template>
  <div
    v-if="getCurrentCustomer.message"
    class="d-flex column align-items-center"
    style="gap: 10px"
  >
    <b-spinner
      v-if="isTefCustomerDocumentWaiting"
      small
    />

    <p class="mb-0 font-weight-bold">
      <b>Cliente: </b>
      <span :class="getCurrentCustomer.class">{{ $t(getCurrentCustomer.message) }}</span>
    </p>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
    BSpinner,
  },

  data() {
    return {}
  },

  computed: {
    ...mapState('pages/pdv/payBox', ['clientForm']),
    ...mapGetters('pages/pdv/payBoxTefRequestData', [
      'isTefCustomerDocumentWaiting',
      'getTefCustomerDocumentMessageError',
    ]),
    ...mapGetters('pages/pdv/payBox', ['hasCustomer']),

    getCurrentCustomer() {
      if (this.isTefCustomerDocumentWaiting) return { message: 'Aguardando resposta do PinPad' }

      if (this.hasCustomer)
        return { message: this.$options.filters?.cpfCnpj(this.clientForm.document) }

      if (this.getTefCustomerDocumentMessageError)
        return { message: this.getTefCustomerDocumentMessageError, class: 'text-danger' }

      return { message: '' }
    },
  },

  methods: {},
}
</script>
